var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dicom-wrapper" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          !_vm.isSharedProfileView
            ? _c(
                "v-btn",
                {
                  staticStyle: { "margin-right": "10px", "margin-top": "7px" },
                  attrs: {
                    color: "#c5c5c5",
                    height: "40",
                    width: "50",
                    "min-width": "50"
                  },
                  on: { click: this.toggleSharingModal }
                },
                [
                  _c("v-icon", { attrs: { size: "25" } }, [
                    _vm._v(" mdi-share ")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticStyle: { "margin-top": "7px" },
              attrs: {
                color: "#c5c5c5",
                height: "40",
                width: "50",
                "min-width": "50"
              },
              on: { click: _vm.handleClose }
            },
            [
              _c("v-icon", { attrs: { size: "25" } }, [
                _vm._v(" mdi-close-thick ")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.patientId && _vm.studyId
        ? _c("iframe", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.iframe.loaded,
                expression: "iframe.loaded"
              }
            ],
            staticClass: "responsive-iframe",
            attrs: {
              src:
                _vm.baseURL() +
                "/dicom/pacs/patient/" +
                _vm.patientId +
                "/study/" +
                _vm.studyId +
                "?X-Ciitizen-Token=" +
                _vm.token() +
                (_vm.grantor ? "&grantor=" + _vm.grantor : ""),
              id: "dicom-viewer"
            },
            on: { load: _vm.onLoad }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ShareModel", {
        attrs: {
          opened: _vm.shareModalOpened,
          userId: _vm.getUserId,
          documentToShare: _vm.doc
        },
        on: { toggleSharingModal: _vm.toggleSharingModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }